import { useState, useEffect, useContext, useRef } from "react";

import PropTypes from "prop-types";

// react-router components
import { Link } from "react-router-dom";

// @mui material components
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";

// Soft UI Dashboard PRO React example components
import DefaultNavbarMenu from "examples/Navbars/DefaultNavbar/DefaultNavbarMenu";
import Divider from "@mui/material/Divider";
import { AccountContext } from "context/account";

const REACT_APP_DEV_MENU = process.env.REACT_APP_DEV_MENU;

function MenuPopper1({ routes, open, close, mobileMenu = false, key }) {
  const account = useContext(AccountContext);

  const renderMenuRoute = () =>
    routes.map((item) => {
      if (REACT_APP_DEV_MENU != "true") {
        //production env
        if (item.dev_menu) {
          //hide development menu
          return;
        }
      }

      let is_hidden = item.hidden || false;
      if (item?.visible_users && item?.visible_users.includes(account.id)) {
        is_hidden = false;
      }

      if (is_hidden || !item.name) {
        return null;
      } else if (item.account_type && item.account_type != account.account_type) {
        return null;
      } else if (!item.collapse || item.noCollapse == true) {
        return (
          <>
            {item?.dividerUp ? <Divider /> : null}
            <MenuItem
              key={item.key}
              component={Link}
              to={item.route}
              onClick={mobileMenu ? undefined : close}
            >
              <SuiBox display="flex" alignItems="center" py={1}>
                {typeof item.icon === "string" ? (
                  <Icon
                    sx={({
                      functions: { linearGradient },
                      palette: { gradients, transparent },
                    }) => ({
                      backgroundImage: `${linearGradient(
                        gradients.info.main,
                        gradients.info.state
                      )} !important`,
                      WebkitBackgroundClip: "text !important",
                      WebkitTextFillColor: `${transparent.main} !important`,
                    })}
                    fontSize="small"
                  >
                    {item.icon}
                  </Icon>
                ) : (
                  item.icon
                )}

                <SuiBox color="text" pl={2} lineHeight={0.5}>
                  {item.name}
                </SuiBox>
              </SuiBox>
            </MenuItem>
            {item?.divider ? <Divider /> : null}
          </>
        );
      } else {
        return item.collapse.map(({ key: collapseKey, route, name, icon }) => (
          <>
            <MenuItem
              key={collapseKey}
              component={Link}
              to={route}
              onClick={mobileMenu ? undefined : close}
            >
              <SuiBox display="flex" alignItems="center" py={1}>
                {typeof icon === "string" ? (
                  <Icon
                    sx={({
                      functions: { linearGradient },
                      palette: { gradients, transparent },
                    }) => ({
                      backgroundImage: `${linearGradient(
                        gradients.info.main,
                        gradients.info.state
                      )} !important`,
                      WebkitBackgroundClip: "text !important",
                      WebkitTextFillColor: `${transparent.main} !important`,
                    })}
                    fontSize="small"
                  >
                    {icon}
                  </Icon>
                ) : (
                  icon
                )}
                <SuiBox color="text" pl={2} lineHeight={0.5}>
                  {name}
                </SuiBox>
              </SuiBox>
            </MenuItem>{" "}
            {item?.divider ? <Divider /> : null}
          </>
        ));
      }
    });

  return mobileMenu ? (
    <SuiBox px={1.5} key={key}>
      {renderMenuRoute()}
    </SuiBox>
  ) : (
    <DefaultNavbarMenu open={open} close={close} key={key}>
      {renderMenuRoute()}
    </DefaultNavbarMenu>
  );
}

export default MenuPopper1;
